var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 14.6484V47.0703H35.1006C31.0063 47.0703 28.8531 49.8465 28.6338 50H21.3662C21.1437 49.8443 19.0213 47.0703 14.8994 47.0703H0V11.7188H2.92969V44.1406H14.9121C19.4904 44.1406 22.0389 46.7237 22.6738 47.0703H27.3262C27.9608 46.7238 30.51 44.1406 35.0879 44.1406H47.0703V14.6484H50Z",
    fill: "#E9E9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5986 42.3799C18.8193 41.6104 16.8945 41.2109 14.9121 41.2109H5.85938V5.85938H8.78906V35.3516H13.1836C17.1758 35.3516 20.4414 38.4775 20.5986 42.3799ZM35.0879 8.78906C31.985 8.78906 28.9964 9.60195 26.3619 11.1563C26.4306 11.8299 26.465 12.5065 26.4648 13.1836V44.0792C26.6865 43.918 26.9119 43.762 27.1409 43.6114C31.664 40.5948 34.7805 41.2109 44.1406 41.2109V8.78906H35.0879Z",
    fill: "#E9E9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5352 42.6758C23.5352 37.0218 18.8915 32.4219 13.1836 32.4219H11.7188V0C19.0421 0 23.5352 5.91416 23.5352 13.1836V42.6758Z",
    fill: "#E9E9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookEnabled);
export default __webpack_public_path__ + "static/media/bookEnabled.822b4092a90e379788806c8ca415034a.svg";
export { ForwardRef as ReactComponent };